import { compact, isEmpty } from "lodash-es";

import { Game } from "./game.model";

export function mapGames(gameIds: string[], games: Record<string, Game>): Game[] {
	return isEmpty(games) ? [] : compact(gameIds.map((id) => games[id]));
}

export function mapGamesByPrimaryVariantId(gameIds: string[], games: Record<string, Game>): Game[] {
	return isEmpty(games)
		? []
		: compact(gameIds.map((id) => Object.values(games).find((game) => game.primaryVariantId === id)));
}

export function getGamesCacheKey(
	customerId: string | undefined,
	countryCode: string | undefined,
	includeHiddenGames: boolean
) {
	return `all-${customerId || "anonymous"}-${countryCode || "any"}${includeHiddenGames ? "-with-hidden-games" : ""}`;
}

export function getGamesByCollectionIdCacheKey(
	collectionId: string,
	customerId: string | undefined,
	countryCode: string | undefined,
	includeHiddenGames: boolean
) {
	return `${collectionId}-${customerId || "anonymous"}-${countryCode || "any"}${includeHiddenGames ? "-with-hidden-games" : ""}`;
}
